import { Stack } from "react-bootstrap"
import useUXStore from "../api/ux/store"
import { PageUnit } from "../api/ux/data"
import Account from "./AccountDropdown"
import { useAuth } from "../api/auth/store"
import Topbar from "./Topbar"

type NavigationProps = {
    initialPage : PageUnit|null
}

const MenuNavigation :React.FC<NavigationProps> = ({initialPage=null}) => {
    const { currentPage, pages, pushPage, popAt } = useUXStore( state => state)
    const { sessionDetails } = useAuth(state => state)
    //console.log(currentPage, initialPage)
    if (!currentPage && initialPage) {
        pushPage(initialPage!.Label, initialPage!.Element)
        return initialPage!.Element
    }
    const onClickPage = (index:number) => {
        popAt(index)
    }
    return (<>
            <Topbar/>
            <Stack className="nav-header-bar" direction="horizontal" gap={3}>
                {
                pages.map((page, index) => (
                    index < pages.length -1 ? 
                        <div key={index+"page"} className="nav-header-inactive" onClick={(_) => onClickPage(index)}>
                            {page.Label}
                        </div> :
                        <div key={index+"page"} className="nav-header-active">{page.Label}</div>
                ))
                }
                
            </Stack>

            {currentPage && currentPage!.Element}
        </>
    )
}

export default MenuNavigation